// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RangeFilter_wrapper__pQhJi","inputs":"RangeFilter_inputs__iqOmb","title":"RangeFilter_title__2P3Yo"};